import { Box, Pagination } from "@mui/material";
import React, {useEffect, useState} from "react";
import LocationCard from "components/cards/LocationCard";


export default function ListWithPagination(props) {

    const { t, dataList, itemComponent: ItemComponent, onMouseEnter, setSelectedStore, pageSize } = props
    const [pagination, setPagination] = useState({
        count: 0,
        from: 0,
        to: pageSize
    })

    const [localList, setLocalList] = useState(dataList)

    const setList = () => {
        if (dataList.length > pageSize) {
            let tempList = dataList.slice(0, pageSize)
            setLocalList(tempList)
        } else {
            setLocalList(dataList)
        }
    }

    useEffect(() => {
        setList()
    }, [])

    useEffect(() => {
        setList()
    }, [dataList])

    useEffect(() => {
        setPagination({ ...pagination, count: pagination.count })
    }, [pagination.from, pagination.to])

    const handlePageChange = (event, page) => {
        const from = (page - 1) * pageSize;
        const to = (page - 1) * pageSize + pageSize
        console.log('changing page: ', page, from, to)
        setPagination({ ...pagination, from: from, to: to })
        let tempList = dataList.slice(from, to)
        setLocalList(tempList)
    }

    return (
        <Box className={'pt-5'}>
            {
                localList.length > 0 ?

                localList.map(location => (
                    <ItemComponent
                        key={location.slug+ location.id}
                        data={location} row
                        className={'mb-4 p-3 rounded-md border'}
                        t={t}
                    />
                )) :
                    <h1 className={"text-sm font-normal italic mb-2 mt-5 text-neutral-400"}>
                        {t('home:notFound')}
                    </h1>
            }
            <Box className='justify-center items-center flex mx-[20px] my-[10px]' >
                <Pagination
                    count={Math.ceil(dataList.length / pageSize)}
                    onChange={handlePageChange}
                />
            </Box>
        </Box>

    )
}
